<template>
    <layout-basic>
        <v-container>
            <section class="banner-text not-found">
                <v-row class="text-center">
                    <v-col md="12">
                        <h1 class="font-sora thanks-title">We could not find that page</h1>
                        <p class="thanks-subtext fs-22">
                            The link may be old or mistyped. These will get you where you were going:
                        </p>
                        <ul class="not-found-links">
                            <li><router-link to="/homepage">Home</router-link></li>
                            <li><router-link to="/pricing">Pricing</router-link></li>
                            <li><router-link to="/course-library">Learning Library</router-link></li>
                            <li><router-link to="/improve-live">IMPROVE Live webinars</router-link></li>
                            <li><router-link to="/contact">Contact us</router-link></li>
                        </ul>
                    </v-col>
                </v-row>
            </section>
        </v-container>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    // Any address the router does not know. Without it an old or mistyped link
    // showed an empty page with no way on. Its page view is grouped not_found
    // (analytics.js), so links into the site that are broken show up in GA4
    // with the address they asked for. Never in the sitemap or the prerender
    // set: it is not in routes.json (siteRoutes.js reads only that).
    export default {
        name: "NotFound",
        components: {
            LayoutBasic,
        },
        metaInfo() {
            return {
                title: "Page not found | IMPROVE",
                meta: [{ name: "robots", content: "noindex, follow" }],
            };
        },
    }
</script>

<style scoped>
.not-found-links {
    list-style: none;
    padding: 0;
    margin: 24px 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px 24px;
    font-size: 18px;
}
</style>
